import React, { useEffect } from "react";
import "../Css/Project.css";
import Slider from "./Slider";
import pro1 from "../Components/image/pro1.png";
import pro2 from "../Components/image/pro2.jpg";
import pro3 from "../Components/image/pro3.jpg";
import pro4 from "../Components/image/pro4.jpg";
import pro5 from "../Components/image/pro5.jpg";
import pro6 from "../Components/image/pro6.jpg";
import pro7 from "../Components/image/pro7.jpg";
import pro8 from "../Components/image/pro8.jpg";
import pro9 from "../Components/image/pro9.jpg";
import pro10 from "../Components/image/pro10.jpg";
import pro11 from "../Components/image/pro11.jpg";
import pro12 from "../Components/image/pro12.jpg";
import pro13 from "../Components/image/pro13.jpg";
import pro14 from "../Components/image/pro14.jpg";
import pro15 from "../Components/image/pro15.jpg";
import Footer from "../Components/Footer";
import Aos from "aos";
import "aos/dist/aos.css";
import { motion, useScroll } from "framer-motion";
function Projects() {
  useEffect(() => {
    document.title = "Projects";
  });
  useEffect(()=>{
   Aos.init({duration:1000})
  },[])
  const { scrollYProgress } = useScroll();

  return (
    <div id="projectmain">
      <motion.div
        style={{
          scaleX: scrollYProgress,
          top: 0,
          left: 0,
          right: 0,
          background: "red",
          height: 4,
          transformOrigin: "0%",
          position: "fixed",
        }}
      />
      <div className="container-fluid" id="slidepart" 
      data-aos="zoom-out"
      >
        <div className="row">{<Slider/>}</div>
      </div>
      <div className="container-fluid"  id="projectheart">
        <div className="row text-center m-4">
          <h1 id="what" 
         >What we do</h1>
          <div className="row " id="protextrow">
            <p id="protext" 
            
            >
              Welcome to our exciting new project! Our team has been hard at
              work developing a cutting-edge solution that will revolutionize
              the industry. We've poured our expertise and creativity into this
              project to create something truly unique and impactful. With
              innovative features and user-friendly design, our solution is sure
              to exceed your expectations. We're committed to delivering a
              product that not only meets your needs but also delights you with
              its simplicity and elegance. Our project is backed by the latest
              technology and rigorous testing, ensuring that it is reliable and
              secure. Join us on this journey as we bring our vision to life and
              make a positive impact on the world. Thank you for your support!
            </p>
          </div>
          <div className="row" id="projectheart2">
            <div className="col-xl-3 shadow " id="project1"   data-aos="slide-up">
              <h4>A Corporate identity</h4>
              <img src={pro1} alt="design1" />
              <h5>Graphic design</h5>
            </div>

            <div className="col-3 shadow" id="project2"   data-aos="slide-up">
              <h4>Brand Campaign</h4>
              <img src={pro2} alt="design2" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project3"   data-aos="flip-right">
              <h4>Web Design Website</h4>
              <img src={pro3} alt="design3" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project4"   data-aos="flip-left">
              <h4> Web Design Website</h4>
              <img src={pro4} alt="design4" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project5"   data-aos="slide-up">
              <h4>Lightboxes</h4>
              <img src={pro5} alt="design5" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project6"   data-aos="slide-up">
              <h4>Flyer design</h4>
              <img src={pro6} alt="design6" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project7"    data-aos="slide-up">
              <h4>Business card</h4>
              <img src={pro7} alt="design7" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project8"    data-aos="slide-up">
              <h4>Business cards</h4>
              <img src={pro8} alt="design8" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project9"    data-aos="slide-up">
              <h4>Business card</h4>
              <img src={pro9} alt="design9" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project10"    data-aos="slide-up">
              <h4>Poseter cards</h4>
              <img src={pro10} alt="design10" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project11"    data-aos="slide-up">
              <h4>Music Template</h4>
              <img src={pro11} alt="design11" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project12"    data-aos="slide-up">
              <h4>Business card </h4>
              <img src={pro12} alt="design12" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project13"    data-aos="zoom-in">
              <h4>Product Design</h4>
              <img src={pro13} alt="design13" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project14"    data-aos="zoom-in">
              <h4>Logo Design</h4>
              <img src={pro14} alt="design14" />
              <h5>Graphic design</h5>
            </div>
            <div className="col-3 shadow" id="project15"    data-aos="zoom-in">
              <h4>Coming soon</h4>
              <img src={pro15} alt="design15" />
              <h5>Graphic design</h5>
            </div>
          </div>
        </div>
        <div className="row">{<Footer />}</div>
      </div>
    </div>
  );
}
export default Projects;
